import { DragEndEvent, DragOverEvent } from "@dnd-kit/abstract";
import { move } from "@dnd-kit/helpers";

export type DragEvent = DragOverEvent & {
  operation: {
    source: { index: number; type: string; group: string };
    target: { index: number; type: string; group: string };
  };
};

export type MoveResult = {
  sourceId: string;
  sourceIndex: number;
  sourceType?: string;
  sourceGroup?: string;
  targetId: string;
  targetIndex: number;
  targetType?: string;
  targetGroup?: string;
  didMove: boolean;
};

export const makeResult = (
  event: DragOverEvent | DragEndEvent,
  didMove: boolean = true,
): MoveResult => {
  const { source, target } = event.operation;
  return {
    sourceId: source?.id as string,
    sourceIndex: (source?.initialIndex as number) || (source?.index as number),
    sourceType: source?.type as string,
    sourceGroup: (source?.initialGroup as string) || (source?.group as string),
    targetId: target?.id as string,
    targetIndex: target?.index as number,
    targetType: target?.type as string,
    targetGroup: target?.group as string,
    didMove: didMove && !event.canceled,
  };
};

export const moveWithId = <Item,>(
  idKey: string,
  items: Item[],
  event: DragOverEvent | DragEndEvent,
): Item[] => {
  const mapped = items.map((item) => {
    (item as any).id = item[idKey as keyof Item];
    return item;
  }) as Array<Item & { id: string }>;
  return move(mapped, event).map(({ id, ...item }) => item) as Item[];
};
